<template>
  <div class="page">
    <!-- 标题栏 -->
    <div class="title">
      <el-image style="width: 22px; height: 22px" :src="require('@/assets/new_icon/xueyuan.png')" />
      <router-link to="/">
        <span :class="{ statusAct: activeNav === null }" @click="handleNavClick(null)">
          导师端学员
          <span style="color: #459EFF">{{ studentCount.total }}</span> 位
        </span>
      </router-link>

      <router-link  to="/user/website">
        <span :class="{ statusAct: activeNav === 2 }" @click="handleNavClick(2)">
          网站学员
          <span style="color: #DC3C00">{{ studentCount.website }}</span> 位
        </span>
      </router-link>

      <span class="add" @click="handleOpenDrawer">
        <el-image class="img" :src="require('@/assets/new_icon/add.png')" />
        添加学员
      </span>
    </div>

    <!-- 筛选栏 -->
    <div class="subject">
      <!-- 科目大类选择 -->
      <el-select v-model="filters.subjectType" placeholder="请选择" size="mini" class="rounded-select" style="width: 120px"
        @change="handleSubjectTypeChange">
        <el-option v-for="item in SUBJECT_TYPES" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <!-- 详细分组科类 -->
      <span v-for="item in currentSubjectDetails" :key="item.id"
        :class="['subject-name', { 'subject-name-act': filters.subjectDetailId === item.id }]"
        @click="handleSubjectDetailClick(item.id)">
        {{ item.name }}
      </span>

      <!-- 排序按钮 -->
      <span class="subject-order" @click="handleOrderToggle">
        按照分数排序
        <el-image class="subject-order-img" :src="require('@/assets/new_icon/order.png')" />
      </span>

      <!-- 搜索框 -->
      <el-input v-model="filters.userName" placeholder="请输入内容" size="mini" style="width: 220px; float: right"
        class="search" clearable @keyup.enter.native="handleSearch">
        <el-button slot="append" size="mini" @click="handleSearch">搜索</el-button>
      </el-input>
    </div>

    <!-- 路由视图 -->
    <router-view :check="requestParams" :onSearch="searchTrigger" @setTotal="handleSetTotal" />

    <!-- 分页 -->
    <div v-if="total > 0" class="pagination">
      <el-pagination :page-size="filters.pageSize" :total="total" layout="prev, pager, next"
        @current-change="handlePageChange" />
    </div>

    <!-- 添加学员抽屉 -->
    <el-drawer :visible.sync="drawerVisible" class="cre" title="添加学员信息" :with-header="false" size="1220px"
      append-to-body destroy-on-close>
      <create_user @closeEdit="handleCloseDrawer" :userData="null" />
    </el-drawer>
  </div>
</template>

<script>
import create_user from './components/editUser'

// 常量配置
const SUBJECT_GROUPS = {
  PHYSICS: {
    value: 1,
    label: '物理组',
    details: [
      { id: 1, name: '物化政' },
      { id: 2, name: '物化地' },
      { id: 3, name: '物生政' },
      { id: 4, name: '物化生' },
      { id: 5, name: '物地政' },
      { id: 6, name: '物生地' }
    ]
  },
  HISTORY: {
    value: 4,
    label: '历史组',
    details: [
      { id: 7, name: '史化政' },
      { id: 8, name: '史政生' },
      { id: 9, name: '史政地' },
      { id: 10, name: '史化地' },
      { id: 11, name: '史化生' },
      { id: 12, name: '史生地' }
    ]
  },
  ALL: {
    value: null,
    label: '全部',
    details: []
  }
}

export default {
  name: 'User',
  components: {
    create_user
  },
  data() {
    return {
      // 常量
      SUBJECT_TYPES: [
        SUBJECT_GROUPS.PHYSICS,
        SUBJECT_GROUPS.HISTORY,
        SUBJECT_GROUPS.ALL
      ],

      // 状态
      activeNav: null,
      drawerVisible: false,
      searchTrigger: 1,
      total: 0,

      // 数据
      expertInfo: null,
      studentCount: {
        total: 0,
        website: 0
      },

      // 筛选参数
      filters: {
        subjectType: null,
        subjectDetailId: null,
        order: 'id',
        userName: null,
        currentPage: 1,
        pageSize: 12
      }
    }
  },

  computed: {
    /**
     * 当前选中的科目大类对应的详细分组
     */
    currentSubjectDetails() {
      const type = this.filters.subjectType
      if (type === SUBJECT_GROUPS.PHYSICS.value) {
        return SUBJECT_GROUPS.PHYSICS.details
      }
      if (type === SUBJECT_GROUPS.HISTORY.value) {
        return SUBJECT_GROUPS.HISTORY.details
      }
      return []
    },

    /**
     * 请求参数（用于传递给子组件）
     */
    requestParams() {
      return {
        subject: this.filters.subjectType,
        subject_id: this.filters.subjectDetailId,
        order: this.filters.order,
        user_name: this.filters.userName,
        currentPage: this.filters.currentPage,
        pageSize: this.filters.pageSize
      }
    }
  },

  created() {
    this.init()
  },

  methods: {
    /**
     * 初始化数据
     */
    init() {
      this.getExpertInfo()
      this.checkLoginState()
      this.fetchStudentCount()
    },

    /**
     * 获取导师信息
     */
    getExpertInfo() {
      const info = localStorage.getItem('ExpertInfo')
      if (info) {
        this.expertInfo = JSON.parse(info)
      }
    },

    /**
     * 检查登录状态
     */
    async checkLoginState() {
      const token = localStorage.getItem('TOKEN')
      if (!token) return

      try {
        const res = await this.$fecth.post('login/checkLoginState', { token })
        console.log('登录状态检查结果:', res)
      } catch (error) {
        console.error('登录状态检查失败:', error)
      }
    },

    /**
     * 获取学员数量统计
     */
    async fetchStudentCount() {
      if (!this.expertInfo) return

      try {
        const res = await this.$fecth.post('user/getUserNum', {
          parent_id: this.expertInfo.id
        })

        if (res.code === 200) {
          this.studentCount = {
            total: res.data.num0,
            website: res.data.num1
          }
        } else {
          console.warn('获取学员数量失败:', res.msg)
        }
      } catch (error) {
        console.error('获取学员数量异常:', error)
      }
    },

    /**
     * 导航点击处理
     */
    handleNavClick(id) {
      this.activeNav = id
      // 重置分页到第一页
      this.filters.currentPage = 1
      // 触发刷新
      this.triggerSearch()
    },

    /**
     * 打开添加学员抽屉
     */
    handleOpenDrawer() {
      this.drawerVisible = true
    },

    /**
     * 关闭添加学员抽屉
     */
    handleCloseDrawer() {
      this.drawerVisible = false
      // 重置到第一页并刷新列表
      this.filters.currentPage = 1
      this.triggerSearch()
    },

    /**
     * 科目大类变更处理
     */
    handleSubjectTypeChange() {
      // 重置详细分类
      this.filters.subjectDetailId = null
      this.triggerSearch()
    },

    /**
     * 详细分类点击处理
     */
    handleSubjectDetailClick(id) {
      // 支持取消选中
      this.filters.subjectDetailId = this.filters.subjectDetailId === id ? null : id
      this.triggerSearch()
    },

    /**
     * 排序切换
     */
    handleOrderToggle() {
      this.filters.order = this.filters.order === 'desc' ? 'asc' : 'desc'
      this.triggerSearch()
    },

    /**
     * 搜索处理
     */
    handleSearch() {
      // 搜索时重置到第一页
      this.filters.currentPage = 1
      this.triggerSearch()
    },

    /**
     * 设置总记录数
     */
    handleSetTotal(total) {
      this.total = total
    },

    /**
     * 分页变更处理
     */
    handlePageChange(page) {
      this.filters.currentPage = page
      this.triggerSearch()
    },

    /**
     * 触发搜索（刷新列表）
     */
    triggerSearch() {
      this.searchTrigger++
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  background: white;
  font-size: 18px;
  padding: 10px 60px;

  .title {
    display: flex;
    align-items: center;
    position: relative;
    padding-bottom: 15px;
    gap: 15px; // 统一设置间距

    padding-top: 15px;
    border-bottom: 1px solid #DFDFDF;

    a {
      color: black;
      text-decoration: none;
    }

    .statusAct {
      border-bottom: 2px solid #2C89FF;
      padding-bottom: 2px;
    }

    .add {
      position: absolute;
      right: 0;
      cursor: pointer;
      display: flex;
      align-items: center;

      .img {
        width: 22px;
        height: 22px;
        margin-right: 5px;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .subject {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    .subject-name {
      border: 1px solid #DFDFDF;
      display: inline-block;
      line-height: 26px;
      padding: 0 18px;
      border-radius: 30px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        border-color: #2B7BF3;
      }
    }

    .subject-name-act {
      background: #2B7BF3;
      color: white;
      border-color: #2B7BF3;
    }

    .subject-order {
      display: inline-flex;
      align-items: center;
      line-height: 26px;
      padding: 0 18px;
      border-radius: 30px;
      cursor: pointer;
      background: #f5f5f5;
      transition: all 0.3s ease;

      &:hover {
        background: #e8e8e8;
      }

      .subject-order-img {
        width: 16px;
        height: 16px;
        margin-left: 6px;
      }
    }
  }

  .pagination {
    background: white;
    padding: 20px 0;
    display: flex;
    justify-content: center;
  }
}

// 全局样式
.rounded-select {
  .el-input__inner {
    border-radius: 30px;
  }
}

.search {
  .el-input__inner {
    border-radius: 30px 0 0 30px;
  }

  .el-input-group__append {
    color: white;
    background: #2B7BF3;
    border-radius: 0 30px 30px 0;
    border: #2B7BF3;

    .el-button {
      color: white;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>